import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="confirm"
export default class extends Controller {
	connect() {}
	deleteConfirm(event) {
		if(!confirm(event.target.dataset.message)){
			event.preventDefault();
		}
	}
	outSubmitConfirm(event) {
		event.preventDefault();
		const button =
			event.target.tagName === "BUTTON"
				? event.target
				: event.target.closest("button");
		if (confirm(button.dataset.message)) {
			if (button.dataset.otherForm) {
				document.getElementById(button.dataset.otherForm).submit();
				button.disabled = true;
			} else {
				const form = button.form;
				if (form) {
					const createParamInput = document.createElement("input");
					createParamInput.type = "hidden";
					createParamInput.name = "create";
					createParamInput.value = "true";
					form.appendChild(createParamInput);
					form.submit();
					button.disabled = true;
				}
			}
		} else {
			return false;
		}

		const modelName = button.dataset.modelName;
		const buttonlName = button.dataset.buttonName;
		const bodyEditId = button.dataset.bodyEditId;

		if ((modelName && bodyEditId) || buttonlName) {
			const newInput = document.createElement('input')
			
			newInput.type = 'hidden';
			newInput.name = `[button_name]`;
			newInput.value = buttonlName;
			button.form.appendChild(newInput);
		}

		if(bodyEditId){
			const newBodyEditIdInput = document.createElement('input')
			newBodyEditIdInput.type = 'hidden';
			newBodyEditIdInput.name = `${[modelName]}[body_edit_id]`;
			newBodyEditIdInput.value = bodyEditId;
			button.form.appendChild(newBodyEditIdInput);
		}
		button.form.submit();
		button.disabled = true;
	}
}
